import React, { useEffect, useRef } from "react";
import { useReducedMotion } from "./hooks";

export function CustomCursor() {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const rm = useReducedMotion();
  useEffect(() => {
    if (rm) return;
    if (!window.matchMedia("(pointer: fine)").matches) return;
    document.body.classList.add("has-custom-cursor");
    let x = window.innerWidth / 2, y = window.innerHeight / 2;
    let rx = x, ry = y;
    let raf = 0;
    const onMove = (e) => { x = e.clientX; y = e.clientY; if (dotRef.current) { dotRef.current.style.transform = `translate(${x}px, ${y}px)`; } };
    const onDown = () => { ringRef.current && ringRef.current.classList.add("is-down"); };
    const onUp   = () => { ringRef.current && ringRef.current.classList.remove("is-down"); };
    const tick = () => {
      rx += (x - rx) * 0.18;
      ry += (y - ry) * 0.18;
      if (ringRef.current) ringRef.current.style.transform = `translate(${rx}px, ${ry}px)`;
      raf = requestAnimationFrame(tick);
    };
    const onOver = (e) => {
      const t = e.target.closest("a, button, [role='button'], input, textarea, select, [data-cursor='hover']");
      if (ringRef.current) ringRef.current.classList.toggle("is-hover", !!t);
    };
    window.addEventListener("pointermove", onMove);
    window.addEventListener("pointerdown", onDown);
    window.addEventListener("pointerup", onUp);
    window.addEventListener("pointerover", onOver);
    raf = requestAnimationFrame(tick);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("pointermove", onMove);
      window.removeEventListener("pointerdown", onDown);
      window.removeEventListener("pointerup", onUp);
      window.removeEventListener("pointerover", onOver);
      document.body.classList.remove("has-custom-cursor");
    };
  }, [rm]);
  if (rm) return null;
  return (
    <>
      <div ref={dotRef}  className="cursor-dot"  aria-hidden="true" />
      <div ref={ringRef} className="cursor-ring" aria-hidden="true">
        <svg viewBox="0 0 40 40" width="40" height="40"><g fill="none" stroke="currentColor" strokeWidth="1"><circle cx="20" cy="20" r="14"/><path d="M20 4 v8 M20 28 v8 M4 20 h8 M28 20 h8" /></g></svg>
      </div>
    </>
  );
}
